import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type RespondedType, ResponseError } from '@/models/response';
import { addTranslateToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { generateTagMemberQueryOptions } from './use-tag-members';
import { tagListQueryOptions } from './use-tags';

export default function useAddTagMembers(tagId: number) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number[]>({
    mutationFn: (userIds) =>
      fetcher('/AddTagMembers', { MemberIds: userIds, TagId: tagId }, { validResponseCodes: [0] }), // 改回正常状态
    onSuccess: () => {
      addTranslateToast({
        type: 'success',
        message: 'common.add-success',
      });

      return Promise.allSettled([
        queryClient.invalidateQueries(tagListQueryOptions),
        queryClient.invalidateQueries(generateTagMemberQueryOptions(tagId)),
      ]);
    },
    onError: (error) => {
      if (ResponseError.isResponseError(error)) {
        addTranslateToast({
          type: 'error',
          message: error.message || 'common.submit-failed',
        });
      } else {
        addTranslateToast({
          type: 'error',
          message: 'common.submit-failed',
        });
      }
    },
  });
}
